import { forwardRef } from 'react'

//* Components
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'

//* Style
import ShopItemStyle from './style'

//* Config
import config from 'helpers/_config'

//* SVG
import { ShopLine } from 'svg'

const ShopItem = forwardRef(({ type, productData, className, iconName }, ref) => {
	return productData ? (
		<ShopItemStyle className={`${className} product`} ref={ref}>
			<CustomLink url={`${config.routes[`shop${type}`].path}/${productData.slug}`} className='link'>
				<div className='relativeWrap'>
					<Image src={productData.featured_image} className='productImage' />
					{iconName && <Icon className={`icon-${iconName} gender-icon`} />}
					{productData.is_daily_price && <Text className='special-price' text={'specialPrice'} />}
				</div>
				<ShopLine />
				<div className='FlexBox shortInfoWrap'>
					<Text className='h8 maisonMedium black productName' text={productData.name} />
					<div className='FlexBox alignMiddle price-cont'>
						<Text className='h8 maisonSemiBold orange price' text={'$' + (productData.sale_price || productData.price)} />
						{productData.sale_price && (
							<>
								<Text className='h8 maisonSemiBold black h10 oldPrice' text={`$${productData.price}`} />
								<Text className='h8 maisonSemiBold black h10 percent' text={`(${productData.sale_percent}% off)`} />
							</>
						)}
					</div>
				</div>
			</CustomLink>
		</ShopItemStyle>
	) : null
})

export default ShopItem
